import { HappyHoursPeriodModel } from './happy-hours.model';
import { Duration } from 'moment';

export class HappyHoursPeriodNextModel extends HappyHoursPeriodModel {
  public get timeLeft(): Duration {
    return this.timeLeftBeforeStart;
  }

}
